(function() {
  'use strict';

  var INTENT_KEY = 'raumstudio_intent';
  var START_PARAM = 'roomvoStartVisualizer';
  var AUTO_START_PARAM = 'roomvoAutoStart';
  var MODAL_ID = 'raumstudio-consent-modal';
  var scriptUrl = window.__roomstudioScriptUrl;

  var scriptPromise = null;
  var scriptLoaded = false;
  var startParamState = null;
  var openSettingsWhenReady = false;
  var activeTrigger = null;

  function getSessionStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function setIntent() {
    var storage = getSessionStorage();
    if (!storage) return;
    try {
      storage.setItem(INTENT_KEY, '1');
    } catch (error) {}
  }

  function clearIntent() {
    var storage = getSessionStorage();
    if (!storage) return;
    try {
      storage.removeItem(INTENT_KEY);
    } catch (error) {}
  }

  function hasIntent() {
    var storage = getSessionStorage();
    if (!storage) return false;
    try {
      return storage.getItem(INTENT_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function normalizeGate(value) {
    if (!value) return 'preferences';
    var gate = String(value).toLowerCase();
    if (gate === 'required' || gate === 'essential') {
      return 'necessary';
    }
    return gate;
  }

  function getRoomvoGate() {
    if (window.__consentGates && window.__consentGates.roomvo) {
      return normalizeGate(window.__consentGates.roomvo);
    }
    return 'preferences';
  }

  function isGateAllowed(gate) {
    if (gate === 'necessary') {
      return true;
    }
    if (typeof window.__cmpIsAllowed === 'function') {
      return !!window.__cmpIsAllowed(gate);
    }
    if (window.Cookiebot && Cookiebot.consent) {
      return !!Cookiebot.consent[gate];
    }
    return false;
  }

  function canSubmitCustomConsent(gate) {
    if (gate === 'necessary') return false;
    return !!(window.Cookiebot && typeof Cookiebot.submitCustomConsent === 'function');
  }

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function openModal(opener) {
    var modal = getModal();
    if (!modal) return;
    clearLoadingState();
    if (typeof modal.open === 'function') {
      modal.open(opener || document.activeElement);
    } else {
      modal.setAttribute('open', '');
    }
    updateModalState();
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    clearLoadingState();
    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
  }

  function setLoadingState(element, isLoading) {
    if (!element || !element.classList) return;
    if (isLoading) {
      activeTrigger = element;
      element.classList.add('is-loading');
      element.setAttribute('aria-busy', 'true');
      element.setAttribute('data-raumstudio-loading', 'true');
      return;
    }
    element.classList.remove('is-loading');
    element.removeAttribute('aria-busy');
    element.removeAttribute('data-raumstudio-loading');
    if (activeTrigger === element) {
      activeTrigger = null;
    }
  }

  function clearLoadingState() {
    if (!activeTrigger) return;
    setLoadingState(activeTrigger, false);
  }

  function updateModalState() {
    var modal = getModal();
    if (!modal) return;
    var startButton = modal.querySelector('[data-raumstudio-start]');
    if (!startButton) return;
    var enabled = canSubmitCustomConsent(getRoomvoGate());
    startButton.disabled = !enabled;
    startButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');
  }

  function getUrl() {
    try {
      return new URL(window.location.href);
    } catch (error) {
      return null;
    }
  }

  function hasStartParam() {
    var url = getUrl();
    return !!(url && url.searchParams.has(START_PARAM));
  }

  function addStartParams(options) {
    var url = getUrl();
    if (!url || !window.history || typeof window.history.replaceState !== 'function') return;
    startParamState = startParamState || {};

    function rememberParam(name) {
      if (Object.prototype.hasOwnProperty.call(startParamState, name)) return;
      startParamState[name] = url.searchParams.has(name) ? url.searchParams.get(name) : null;
    }

    function setParam(name, value) {
      rememberParam(name);
      url.searchParams.set(name, value);
    }

    setParam(START_PARAM, 'true');
    setParam(AUTO_START_PARAM, 'true');
    if (options && options.sku) {
      setParam('sku', options.sku);
    }

    window.history.replaceState({}, '', url.toString());
  }

  function cleanupStartParams() {
    if (!startParamState) return;
    var url = getUrl();
    if (!url || !window.history || typeof window.history.replaceState !== 'function') return;
    Object.keys(startParamState).forEach(function(name) {
      var previousValue = startParamState[name];
      if (previousValue === null) {
        url.searchParams.delete(name);
      } else {
        url.searchParams.set(name, previousValue);
      }
    });
    window.history.replaceState({}, '', url.toString());
    startParamState = null;
  }

  function getScriptConsentAttribute(gate) {
    var normalizedGate = normalizeGate(gate);
    if (!normalizedGate || normalizedGate === 'necessary') return '';
    return normalizedGate;
  }

  function loadRoomstudioScriptOnce(gate) {
    if (scriptPromise) return scriptPromise;
    if (window._roomvo || window.roomvo) {
      scriptLoaded = true;
      scriptPromise = Promise.resolve();
      return scriptPromise;
    }
    if (!scriptUrl) {
      scriptPromise = Promise.reject(new Error('Roomstudio script URL not set'));
      return scriptPromise;
    }

    scriptPromise = new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.defer = true;
      var consentAttr = getScriptConsentAttribute(gate);
      if (consentAttr) {
        script.setAttribute('data-cookieconsent', consentAttr);
      }
      script.onload = function() {
        scriptLoaded = true;
        resolve();
      };
      script.onerror = function() {
        reject(new Error('Roomstudio script failed to load'));
      };
      document.head.appendChild(script);
    });

    return scriptPromise;
  }

  function isScriptReady() {
    return scriptLoaded || !!window._roomvo || (window.roomvo && (window.roomvo.startStandalone || window.roomvo.startStandaloneVisualizer));
  }

  function getRoomvoButton() {
    return document.querySelector('.roomvo-stimr');
  }

  function getRoomvoSku(button) {
    var target = button || getRoomvoButton();
    if (!target) return '';
    return target.getAttribute('data-roomvo-product-code') || target.getAttribute('data-sku') || '';
  }

  function openRoomstudioFallback() {
    closeModal();
    var button = getRoomvoButton();
    if (button) {
      button.click();
      return;
    }
    if (window.roomvo && typeof window.roomvo.startStandaloneVisualizer === 'function') {
      try {
        window.roomvo.startStandaloneVisualizer();
      } catch (error) {}
    }
  }

  function isRoomvoOpen() {
    return !!(
      document.getElementById('roomvo-lite-iframe') ||
      document.getElementById('roomvoProductDisplay') ||
      document.getElementById('roomvoProductCatalog') ||
      document.getElementById('roomvoStoreLocator') ||
      document.getElementById('roomvoMeasurement') ||
      document.getElementById('ffPopup')
    );
  }

  function waitForRoomvoOpen(options) {
    var attempts = 0;
    var maxAttempts = 8;
    var interval = 250;
    var allowFallback = !options || options.allowFallback !== false;

    function check() {
      if (isRoomvoOpen()) {
        cleanupStartParams();
        clearIntent();
        clearLoadingState();
        return;
      }
      attempts += 1;
      if (attempts >= maxAttempts) {
        if (allowFallback) {
          openRoomstudioFallback();
        }
        cleanupStartParams();
        clearIntent();
        clearLoadingState();
        return;
      }
      setTimeout(check, interval);
    }

    setTimeout(check, 100);
  }

  function ensureRoomstudio(opener, options) {
    var gate = getRoomvoGate();
    if (!isGateAllowed(gate)) {
      openModal(opener);
      return Promise.resolve(false);
    }
    if (opener) {
      setLoadingState(opener, true);
    }
    addStartParams(options);
    return loadRoomstudioScriptOnce(gate)
      .then(function() {
        waitForRoomvoOpen({ allowFallback: true });
        return true;
      })
      .catch(function() {
        clearLoadingState();
        return false;
      });
  }

  function maybeStartFromIntent() {
    if (!hasIntent()) return;
    if (!isGateAllowed(getRoomvoGate())) return;
    ensureRoomstudio();
  }

  function openSettings(allowDefer) {
    if (typeof window.__cmpOpenSettings === 'function') {
      window.__cmpOpenSettings();
      if (allowDefer && !window.Cookiebot) {
        openSettingsWhenReady = true;
      }
      return;
    }
    if (window.Cookiebot) {
      if (typeof Cookiebot.renew === 'function') {
        Cookiebot.renew();
      } else if (typeof Cookiebot.show === 'function') {
        Cookiebot.show();
      }
    } else if (allowDefer) {
      openSettingsWhenReady = true;
    }
  }

  function handlePrimaryClick(evt) {
    evt.preventDefault();
    setIntent();
    var gate = getRoomvoGate();
    if (!canSubmitCustomConsent(gate)) {
      updateModalState();
      return;
    }
    var prefs = Cookiebot.consent ? !!Cookiebot.consent.preferences : false;
    var stats = Cookiebot.consent ? !!Cookiebot.consent.statistics : false;
    var marketing = Cookiebot.consent ? !!Cookiebot.consent.marketing : false;
    if (gate === 'preferences') {
      prefs = true;
    } else if (gate === 'statistics') {
      stats = true;
    } else if (gate === 'marketing') {
      marketing = true;
    }
    Cookiebot.submitCustomConsent(prefs, stats, marketing);
    maybeStartFromIntent();
  }

  function handleSecondaryClick(evt) {
    evt.preventDefault();
    setIntent();
    closeModal();
    openSettings(true);
  }

  function handleTertiaryClick(evt) {
    evt.preventDefault();
    clearIntent();
    clearLoadingState();
    closeModal();
  }

  function isStartLink(link) {
    if (!link) return false;
    if (link.hasAttribute('data-raumstudio-open')) return true;
    var href = link.getAttribute('href') || '';
    return href.indexOf(START_PARAM) !== -1;
  }

  function handleDocumentClick(evt) {
    if (!evt || evt.defaultPrevented) return;
    if (evt.isTrusted === false) return;
    var target = evt.target;
    if (!target || !target.closest) return;

    var link = target.closest('a[href]');
    if (link && isStartLink(link)) {
      if (link.getAttribute('data-raumstudio-loading') === 'true') {
        evt.preventDefault();
        return;
      }
      evt.preventDefault();
      setIntent();
      setLoadingState(link, true);
      ensureRoomstudio(link);
      return;
    }

    var roomvoButton = target.closest('.roomvo-stimr');
    if (roomvoButton) {
      if (roomvoButton.getAttribute('data-raumstudio-loading') === 'true') {
        evt.preventDefault();
        return;
      }
      var gate = getRoomvoGate();
      if (!isGateAllowed(gate)) {
        evt.preventDefault();
        setIntent();
        openModal(roomvoButton);
        return;
      }
      setLoadingState(roomvoButton, true);
      if (!isScriptReady()) {
        evt.preventDefault();
        setIntent();
        ensureRoomstudio(roomvoButton, { sku: getRoomvoSku(roomvoButton) });
        return;
      }
      waitForRoomvoOpen({ allowFallback: false });
    }
  }

  function bindModalButtons() {
    var modal = getModal();
    if (!modal || modal.__raumstudioBound) return;
    modal.__raumstudioBound = true;

    var startButton = modal.querySelector('[data-raumstudio-start]');
    if (startButton) {
      startButton.addEventListener('click', handlePrimaryClick);
    }
    var settingsButton = modal.querySelector('[data-raumstudio-settings]');
    if (settingsButton) {
      settingsButton.addEventListener('click', handleSecondaryClick);
    }
    var cancelButtons = modal.querySelectorAll('[data-raumstudio-cancel]');
    for (var i = 0; i < cancelButtons.length; i++) {
      cancelButtons[i].addEventListener('click', handleTertiaryClick);
    }
  }

  function handleCookiebotReady() {
    updateModalState();
    if (openSettingsWhenReady) {
      openSettingsWhenReady = false;
      openSettings(false);
    }
    maybeStartFromIntent();
  }

  function handleCookiebotDecline() {
    clearIntent();
    updateModalState();
  }

  function handleCookiebotWithdraw() {
    updateModalState();
  }

  function init() {
    bindModalButtons();
    document.addEventListener('click', handleDocumentClick);
    window.addEventListener('CookiebotOnConsentReady', handleCookiebotReady);
    window.addEventListener('CookiebotOnAccept', handleCookiebotReady);
    window.addEventListener('CookiebotOnDecline', handleCookiebotDecline);
    window.addEventListener('CookiebotOnWithdraw', handleCookiebotWithdraw);
    updateModalState();

    if (hasStartParam()) {
      setIntent();
      ensureRoomstudio();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
